import { apiClient } from "@/shared/api";
import { PagedResult } from "@/shared/types";
import { type ApiResult } from "@/shared/utils";
import { OrganizationRequestDto, OrganizationResponseDto, SearchOrganizationRequestDto, UpdateOrganizationRequestDto } from "../types";
import { organizationApiMock as mockApi } from "./organization.api.mock";

const getOrganizations = (params?: SearchOrganizationRequestDto) => {
    const queryParams = new URLSearchParams();
    if (params?.limit) queryParams.append('limit', params.limit.toString());
    if (params?.paginationToken) queryParams.append('paginationToken', params.paginationToken);

    const queryString = queryParams.toString();
    return apiClient.get<PagedResult<OrganizationResponseDto>>(`/Organizations${queryString ? `?${queryString}` : ''}`)
}

const getOrganizationById = (organizationId: string) => {
    return apiClient.get<OrganizationResponseDto>(`/Organizations/${organizationId}`)
}

const createOrganization = (request: OrganizationRequestDto) => {
    return apiClient.post<OrganizationResponseDto>(`/Organizations`, request);
}

const updateOrganization = (organizationId: string, request: UpdateOrganizationRequestDto): Promise<ApiResult<OrganizationResponseDto>> => {
    return apiClient.put<OrganizationResponseDto>(`/Organizations/${organizationId}`, request);
}

const deleteOrganization = (organizationId: string): Promise<ApiResult<void>> => {
    return apiClient.delete<void>(`/Organizations/${organizationId}`);
}

export const realApi = {
    getOrganizations,
    getOrganizationById,
    createOrganization,
    updateOrganization,
    deleteOrganization
}

export const organizationApi = import.meta.env.VITE_MOCK_API === 'true' ? mockApi : realApi;

